import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Grid,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default function WarrantyAccordion({
  title,
  warranties,
  setWarranties,
}) {
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [errors, setErrors] = useState({
    plan: "",
    price: "",
    text: "",
  });

  const [formData, setFormData] = useState({
    plan: "",
    price: "",
    text: "",
  });

  const editorOptions = {
    height: "200px",
    buttonList: [
      ["bold", "italic", "underline"],
      ["list", "align"],
      ["link"],
      ["removeFormat"],
    ],
  };

  /* ---------------- ADD / UPDATE ---------------- */

  // const handleSubmit = () => {
  //   if (!formData.plan || !formData.text) return;

  //   const payload = {
  //     plan: formData.plan,
  //     price: formData.price,
  //     text: formData.text,
  //   };

  //   if (isEdit) {
  //     setWarranties((prev) =>
  //       prev.map((w) => (w.id === editId ? { ...w, ...payload } : w))
  //     );
  //   } else {
  //     setWarranties((prev) => [
  //       ...prev,
  //       { id: crypto.randomUUID(), ...payload },
  //     ]);
  //   }

  //   resetDialog();
  // };

  const handleSubmit = () => {
    const newErrors = {
      plan: "",
      price: "",
      text: "",
    };

    if (!formData.plan.trim()) newErrors.plan = "Plan is required";
    if (!formData.price.trim()) {
      newErrors.price = "Price is required";
    } else if (!/^\d+$/.test(formData.price)) {
      newErrors.price = "Price must be a number";
    }

    if (!formData.price.trim()) newErrors.price = "Price is required";
    if (!formData.text.trim()) newErrors.text = "Description is required";

    setErrors(newErrors);

    // ❌ stop submit if any error exists
    if (Object.values(newErrors).some(Boolean)) return;

    const payload = {
      plan: formData.plan,
      price: formData.price,
      text: formData.text,
    };

    if (isEdit) {
      setWarranties((prev) =>
        prev.map((w) => (w.id === editId ? { ...w, ...payload } : w))
      );
    } else {
      setWarranties((prev) => [
        ...prev,
        { id: crypto.randomUUID(), ...payload },
      ]);
    }

    resetDialog();
  };

  /* ---------------- EDIT ---------------- */

  const handleEdit = (item) => {
    setIsEdit(true);
    setEditId(item.id);
    setFormData({
      plan: item.plan,
      price: item.price,
      text: item.text,
    });
    editorInitialized.current = false;
    setOpen(true);
  };

  /* ---------------- DELETE ---------------- */

  // const handleDelete = (id) => {
  //   setWarranties((prev) => prev.filter((w) => w.id !== id));
  // };
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = () => {
    setWarranties((prev) => prev.filter((w) => w.id !== deleteId));
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };

  const cancelDelete = () => {
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };

  /* ---------------- RESET ---------------- */

  // const resetDialog = () => {
  //   setOpen(false);
  //   setIsEdit(false);
  //   setEditId(null);
  //   setFormData({ plan: "", price: "", text: "" });
  //   editorInitialized.current = false;
  // };
  const resetDialog = () => {
    setOpen(false);
    setIsEdit(false);
    setEditId(null);
    setFormData({ plan: "", price: "", text: "" });
    setErrors({ plan: "", price: "", text: "" });
    editorInitialized.current = false;
  };

  const editorRef = React.useRef(null);
  const editorInitialized = React.useRef(false);

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography fontWeight={600}>{title}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Button
          variant="contained"
          sx={{ mb: 2 }}
          onClick={() => setOpen(true)}
        >
          Add Warranty
        </Button>

        {warranties.map((item) => (
          <Paper key={item.id} sx={{ p: 2, mb: 2 }}>
            <Grid container justifyContent="space-between">
              <Typography fontWeight={600}>{item.plan}</Typography>
              <div>
                <IconButton onClick={() => handleEdit(item)}>
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => handleDeleteClick(item.id)}>
                  <DeleteIcon />
                </IconButton>
              </div>
            </Grid>

            {item.price && (
              <Typography variant="body2">
                <strong>Price:</strong> {item.price}
              </Typography>
            )}

            <div
              dangerouslySetInnerHTML={{ __html: item.text }}
              style={{ marginTop: 8 }}
            />
          </Paper>
        ))}

        {/* ---------------- DIALOG ---------------- */}

        <Dialog open={open} onClose={resetDialog} fullWidth maxWidth="sm">
          <DialogTitle>{isEdit ? "Edit Warranty" : "Add Warranty"}</DialogTitle>

          <DialogContent dividers>
            {/* <TextField
              fullWidth
              size="small"
              label="Plan"
              sx={{ mb: 2 }}
              value={formData.plan}
              onChange={(e) =>
                setFormData({ ...formData, plan: e.target.value })
              }
            /> */}
            <TextField
              fullWidth
              required
              size="small"
              label="Plan"
              sx={{ mb: 2 }}
              value={formData.plan}
              error={!!errors.plan}
              helperText={errors.plan}
              onChange={(e) => {
                setFormData({ ...formData, plan: e.target.value });
                setErrors({ ...errors, plan: "" });
              }}
            />

            {/* <TextField
              fullWidth
              size="small"
              label="Price"
              sx={{ mb: 2 }}
              value={formData.price}
              onChange={(e) =>
                setFormData({ ...formData, price: e.target.value })
              }
            /> */}

            {/* <TextField
              fullWidth
              required
              size="small"
              label="Price"
              sx={{ mb: 2 }}
              value={formData.price}
              error={!!errors.price}
              helperText={errors.price}
              onChange={(e) => {
                setFormData({ ...formData, price: e.target.value });
                setErrors({ ...errors, price: "" });
              }}
            /> */}

            <TextField
              fullWidth
              required
              size="small"
              label="Price"
              sx={{ mb: 2 }}
              value={formData.price}
              error={!!errors.price}
              helperText={errors.price}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              onChange={(e) => {
                const value = e.target.value;

                // ❌ allow only digits
                if (!/^\d*$/.test(value)) {
                  setErrors((prev) => ({
                    ...prev,
                    price: "Please enter numbers only",
                  }));
                  return;
                }

                setFormData({ ...formData, price: value });
                setErrors({ ...errors, price: "" });
              }}
            />

            <Typography fontWeight={600} sx={{ mb: 1 }}>
              Description
            </Typography>

            {/* <SunEditor
              setOptions={editorOptions}
              // setContents={formData.text}
              onChange={(content) =>
                setFormData({ ...formData, text: content })
              }
            /> */}
            <SunEditor
              getSunEditorInstance={(editor) => {
                editorRef.current = editor;
              }}
              onLoad={() => {
                if (!editorInitialized.current) {
                  editorRef.current.setContents(formData.text || "");
                  editorInitialized.current = true;
                }
              }}
              setOptions={editorOptions}
              // onChange={(content) =>
              //   setFormData((prev) => ({ ...prev, text: content }))
              // }
              onChange={(content) => {
                setFormData((prev) => ({ ...prev, text: content }));
                setErrors((prev) => ({ ...prev, text: "" }));
              }}
            />
            {errors.text && (
              <Typography color="error" variant="caption">
                {errors.text}
              </Typography>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={resetDialog}>Cancel</Button>
            <Button variant="contained" onClick={handleSubmit}>
              {isEdit ? "Update" : "Add"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openDeleteDialog} onClose={cancelDelete}>
          <DialogTitle>Confirm Delete</DialogTitle>

          <DialogContent>
            <Typography>
              Are you sure you want to delete this warranty?
            </Typography>
          </DialogContent>

          <DialogActions>
            <Button onClick={cancelDelete}>No</Button>
            <Button color="error" variant="contained" onClick={confirmDelete}>
              Yes, Delete
            </Button>
          </DialogActions>
        </Dialog>
      </AccordionDetails>
    </Accordion>
  );
}
